import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useLanguageContext } from "../../../Context/LanguageContext";
import AddIcon from "@mui/icons-material/Add";
import { AiOutlineDelete } from "react-icons/ai";
import { Button, Typography } from "@mui/material";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import UserManagementActions from "../../../Actions/UserManagementActions";
import usermanagementStore from "../../../Stores/UsermanagementStore";
import UsermanagementConstants from "../../../Constants/UsermanagementConstants";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
export default function Responsibilty(props) {
  const { equipmentGrpId, setEqupGrupUserListFlag } = props.data;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [tableData, settableData] = useState(null);
  const columns = [
    {
      field: "firstName",
      headerName: localization.firstName,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    {
      field: "surName",
      headerName: localization.surname,
      hideable: false,
      flex: 1,
    },
    {
      field: "username",
      headerName: localization.userName,
      hideable: false,
      flex: 1,
    },
    {
      field: "email",
      headerName: localization.email,
      hideable: false,
      flex: 1,
    },
  ];

  const getEquipmentGroupResponsibleUsers = () => {
    setGlobalSpinner(true);
    UserManagementActions.getEquipmentGroupResponsibleUsers(equipmentGrpId);
  };

  useEffect(() => {
    getEquipmentGroupResponsibleUsers();

    function getResponsibleUserSuccess() {
      const res = usermanagementStore.getResponsibleUserList();
      if (res) {
        settableData(res);
        setGlobalSpinner(false);
      }
    }

    function getResponsibleUserFailure() {
      var res = usermanagementStore.getResponsibleUserList();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
      getResponsibleUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
      getResponsibleUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
        getResponsibleUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
        getResponsibleUserFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getAddResponsibleUserSuccess() {
      const res = usermanagementStore.getAddResponsibleUserRes();
      setGlobalSpinner(false);
      if (res) {
        commonUtils.hideModalPopUp("addResFormModalClose");
        toast.success(localization.addResponsibleUserSuccess);
        getEquipmentGroupResponsibleUsers();
      } else {
        toast.error(res);
      }
    }

    function getAddResponsibleUserFailure() {
      var res = usermanagementStore.getAddResponsibleUserRes();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
      getAddResponsibleUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
      getAddResponsibleUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_SUCCESS,
        getAddResponsibleUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADD_EQUIP_GRP_RESPONSIBLE_USER_FAILURE,
        getAddResponsibleUserFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteResponsibleUserSuccess() {
      const res = usermanagementStore.getDeleteResponsibleUserRes();
      setGlobalSpinner(false);
      if (res) {
        toast.success(localization.deleteResponsibleUserSuccess);
        getEquipmentGroupResponsibleUsers();
      } else {
        toast.error(res);
      }
    }

    function deleteResponsibleUserFailure() {
      var res = usermanagementStore.getDeleteResponsibleUserRes();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_RESPONSIBLE_USER_SUCCESS,
      deleteResponsibleUserSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_RESPONSIBLE_USER_FAILURE,
      deleteResponsibleUserFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_RESPONSIBLE_USER_SUCCESS,
        deleteResponsibleUserSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_RESPONSIBLE_USER_FAILURE,
        deleteResponsibleUserFailure,
      );
    };
  }, []);

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_RESPONSIBLE_USER":
          setGlobalSpinner(true);
          UserManagementActions.deleteResponsibleUserForEqupGroup({
            AnlagegruppeID: equipmentGrpId,
            UserIDs: data.userIDs,
          });
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }

  function RenderAddHersteller() {
    return (
      <>
        <Button
          id="adduser"
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addResForm"
          onClick={() => setEqupGrupUserListFlag(true)}
        >
          {localization.addResponsibleUser}
        </Button>
      </>
    );
  }

  function RenderDeleteButton() {
    return (
      <>
        <Button
          className="mr-4 cursorPoint svgIcon"
          variant="outlined"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  const handleAdd = () => {};

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteResponsibleUserCallback(_idList);
  };

  function deleteResponsibleUserCallback(userIDs) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteResponsibleUserConfirmationText);
    setCallbackData({
      userIDs: userIDs,
    });
    setEventType("DELETE_RESPONSIBLE_USER");
  }

  const operations = {
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddHersteller />,
        onClick: handleAdd,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  return (
    <>
      <div>
        <Typography variant="h2">{localization.responsibilities}</Typography>
        <Typography variant="body2" gutterBottom>
          {localization.responsibilitiesDesc}
        </Typography>
      </div>
      {tableData && (
        <CustomDataGrid
          columns={columns}
          rows={tableData}
          operations={operations}
          onAdd={handleAdd}
          showExport={true}
          showColumns={true}
          showFilters={true}
          showDensity={true}
          visibleColumns={["firstName", "surName", "username", "email"]}
          showCheckBox={true}
          gridTableHeight={"dataGridResponsibility"}
        />
      )}
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
}
